<template>
  <b-modal
    id="modal-edit-order"
    centered
    size="lg"
    title="修改入貨單"
    hide-footer
    @hide="resetModal"
  >
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <!-- 日期 -->
            <b-col cols="12">
              <validation-provider
                #default="validationContext"
                name="日期"
                rules="required"
              >
                <b-form-group label="日期" label-for="order_date">
                  <flat-pickr
                    v-model="orderData.order_date"
                    class="form-control"
                    :config="{ dateFormat: 'Y-m-d' }"
                    placeholder="YYYY-MM-DD"
                  />

                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- 備註 -->
            <b-col cols="12">
              <b-form-group label="備註" label-for="remark">
                <b-form-textarea
                  id="remark"
                  v-model="orderData.remark"
                  placeholder="備註"
                  rows="3"
                />
              </b-form-group>
            </b-col>

            <!-- 按鈕 -->
            <b-col cols="12" class="text-center mt-2">
              <b-button variant="primary" class="mr-1" type="submit">
                儲存
              </b-button>
              <b-button variant="outline-secondary" @click="hide">
                取消
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BForm,
  BFormGroup,
  BFormTextarea,
  BButton,
  BOverlay,
  BRow,
  BCol,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import formValidation from "@core/comp-functions/forms/form-validation";
import store from "@/store";

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormTextarea,
    BButton,
    BOverlay,
    BRow,
    BCol,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
  },
  props: {
    orderData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-edit-order");
    },
    resetModal() {
      this.$emit("modal-hidden");
    },
    onSubmit() {
      this.$swal({
        title: "確認儲存?",
        showCancelButton: true,
        confirmButtonText: "儲存",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app-order/updateOrder", this.orderData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const { refFormObserver, getValidationState } = formValidation();

    return {
      refFormObserver,
      getValidationState,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
